
            const data = {"name":"feather/power","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                